import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Grid , Divider} from '@material-ui/core';
import { } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        margin: 'auto',
        width: '75%',
      },
      container: {
        display: 'block',
        flexWrap: 'wrap',
        padding: 20,
        width: '75%',
        margin: 'auto',
        alignItems: 'center'
      },
      textField: {
        paddingTop: 20,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
       
      },
      paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
      button: {
        margin: theme.spacing.unit,
      },
})
class MySubjects extends Component{
    constructor(props){
        super(props)
        this.state = {
            subjMap: [],
            loading: true
        }
    }

    componentDidMount(){
        var myYear
        var myLevel
        var myAbility
        var objMe = {}
        var subjMap = []
        var studentRef = db.collection('Users').where('UID', '==', sessionStorage.getItem('uid'))



        studentRef.get()
            .then(snapshot => { 
                snapshot.forEach(doc => { 
                    var data = doc.data()
                    myLevel = data.CurrentLevel
                    myAbility = data.ability
                    myYear = data.CurrentYear
                
                
                objMe = { 
                    id : sessionStorage.getItem('uid'),
                    level: myLevel,
                    year: myYear, 
                    ability: myAbility
                }
                console.log(subjMap)
                        this.setState({
                            me: objMe,
                        })
                console.log(objMe)
                var subjRef =  db.collection('Level').doc(myLevel).collection('Subjects')

                subjRef.get()
                    .then(snapshot => { 
                        snapshot.forEach( doc => {
                            // console.log(doc)
                            var subject = doc.id
                            db.collection('Level').doc(myLevel).collection('Subjects').doc(subject).collection('Years').doc(myYear).collection('Abilities').doc(myAbility).get()
                                .then(snapshot => {
                                    console.log(snapshot.data())
                                    var content = snapshot.data().data.Content.Sections
                                    this.state.subjMap.push({ id: subject, content:  content})
                                })
                                    // console.log(ref.data(), ref.exists, ref.id, ref.docs, myLevel, myAbility, myYear, subject)
                                })
                        })
                    })
        })
    }

    render(){
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Grid container
                    spacing={24}
                    direction='row'
                    justify='space-evenly'
                    alignContent='center'
                >
                    {this.state.me && this.state.subjMap? 
                        <Grid item xs={12}>
                        {console.log(this.state.subjMap)}
                            <Paper className={classes.paper}>
                            <Typography variant='headline'>
                                Subjects and Content for {this.state.me.level + ' - Year ' + this.state.me.year }
                                <Divider/>
                                <br/>
                            </Typography>
                            <Grid container
                                spacing={24}
                                direction='row'
                                justify='space-evenly'
                                alignContent='center'
                            >
                            {this.state.subjMap.map(subject => {
                                return (
                                    <Grid item xs={4}>
                                        <Paper className={classes.paper}>
                                            <Typography variant='headline'>
                                                {subject.id}
                                                <Divider/>
                                                <br/>
                                            </Typography>
                                            {subject.content.map( section => {
                                                return (
                                                    <div>
                                                        <Typography variant='title'>
                                                            {section.Name}
                                                        </Typography>
                                                        <Typography variant='body2'>
                                                            {section.HWK.length + ' Homework Tasks'}
                                                            <br/>
                                                            {section.Tests.length + ' Tests'}
                                                        </Typography>
                                                        <br/>
                                                        <Divider/>
                                                        <br/>
                                                    </div>
                                                )
                                            })}
                                            <Button variant='outlined' onClick={() => window.location.replace('/' + sessionStorage.getItem('uid') + '/levels/' + this.state.me.level + '/' + subject.id + '/' + this.state.me.year + '/' + this.state.me.ability )}>
                                                View subject
                                            </Button>
                                        </Paper>
                                    </Grid>
                                )
                            })}
                            </Grid>
                            </Paper>
                        </Grid>

                    :
                    <Grid container
                    spacing={24}
                    direction='row'
                    justify='space-evenly'
                    alignContent='center'
                >
                    <br/>
                    {this.state.loading ? 
                        <Grid item xs={3}>
                                <div style={{width: '100%', alignItems: 'center'}}>
                                    <CircularProgress className={classes.progress} color="inherit" />
                                </div> 
                                {setTimeout(() => {this.setState({loading: false})}, 2000)}
                        </Grid>  
                    :
                        <Grid item xs={6}>
                            <Typography variant='subheading' style={{marginTop: 20}}>
                                You have no year groups for this subject
                            </Typography>
                        </Grid> 
                    }
                </Grid>
                    
                    }
                    
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(MySubjects);


// WEBPACK FOOTER //
// ./src/pages/View/mysubjects.jsx